import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const AITPRJ02 = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO SECTION */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage: "url('/Images/tour/c48972d4-33c_big.jpg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Golden Triangle Tour (AITP / RJ-02)</h1>

            <p className="hero-subtitle">
              4 Nights / 5 Days • Delhi – Agra – Jaipur
            </p>

            <div className="hero-price">
              Starting From <span>₹15,800*</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + FORM */}
        <Row className="mb-4">

          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/6d320661-448_big.jpg" alt="" />
                <img src="/Images/tour/fa11333f-ae2_big.jpg" alt="" />
                <img src="/Images/tour/5c7cc174-635_big.jpg" alt="" />
              </Slider>
            </div>
          </Col>

          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹15,800*</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>

        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Golden Triangle Tour</h1>
              <p>Delhi • Agra • Jaipur | 4 Nights / 5 Days</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Raj Ghat Delhi</Col>
                <Col md={6}>✔ Taj Mahal Agra</Col>
                <Col md={6}>✔ Agra Fort</Col>
                <Col md={6}>✔ Fatehpur Sikri</Col>
                <Col md={6}>✔ Amber Fort Jaipur</Col>
                <Col md={6}>✔ Hawa Mahal Jaipur</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Experience India's most famous travel circuit — the Golden
                Triangle Tour covering Delhi, Agra and Jaipur. Discover
                Mughal heritage, royal palaces, UNESCO monuments and vibrant
                local markets across North India.
              </p>
            </div>

            {/* Itinerary */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Day 1 – Arrival Delhi & Sightseeing
                  </Accordion.Header>
                  <Accordion.Body>
                    Arrival pickup and hotel check-in. Visit Jama Masjid,
                    India Gate, Qutub Minar, Humayun's Tomb, Raj Ghat,
                    Parliament House and Connaught Place. Overnight stay
                    in Delhi.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Delhi to Agra
                  </Accordion.Header>
                  <Accordion.Body>
                    Drive to Agra via Mathura & Vrindavan temples.
                    Visit Taj Mahal, Agra Fort and Itimad-Ud-Daulah
                    Tomb. Overnight stay in Agra.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Agra to Jaipur via Fatehpur Sikri
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Fatehpur Sikri en route to Jaipur.
                    Hotel check-in and overnight stay in Jaipur.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Day 4 – Jaipur Sightseeing
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Amber Fort, Jal Mahal, City Palace,
                    Jantar Mantar and Hawa Mahal. Evening shopping
                    at local markets. Overnight stay in Jaipur.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    Day 5 – Jaipur to Delhi Departure
                  </Accordion.Header>
                  <Accordion.Body>
                    After breakfast depart for Delhi.
                    Drop at airport or railway station.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* Inclusions / Exclusions */}
            <div className="content-box">
              <Row>
                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul>
                    <li>Hotel Accommodation</li>
                    <li>Daily Breakfast & Dinner</li>
                    <li>Private Transport</li>
                    <li>All Sightseeing Tours</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul>
                    <li>Monument Entry Fees</li>
                    <li>Personal Expenses</li>
                    <li>Travel Insurance</li>
                    <li>Lunch & Tips</li>
                  </ul>
                </Col>
              </Row>
            </div>

            {/* Hotel Details */}
            <div className="content-box">
              <h3>Hotel Details</h3>
              <p>
                Comfortable deluxe hotels in Delhi, Agra and Jaipur with
                modern amenities and daily breakfast.
              </p>
            </div>

            {/* Rate Summary */}
            <div className="content-box">
              <h3>Rate & Summary</h3>
              <p>
                Starting price ₹15,800 per person on twin sharing basis.
                Rates may vary depending on travel dates and availability.
              </p>
            </div>

            {/* Terms */}
            <div className="content-box">
              <h3>Terms & Conditions</h3>
              <ul>
                <li>Booking subject to availability.</li>
                <li>50% advance payment required.</li>
                <li>Cancellation policy applicable.</li>
              </ul>
            </div>

            {/* Travel Tips */}
            <div className="content-box">
              <h3>Travel Tips</h3>
              <ul>
                <li>Carry valid ID proof.</li>
                <li>Best travel season: Oct – March.</li>
                <li>Wear comfortable footwear.</li>
                <li>Stay hydrated during sightseeing.</li>
              </ul>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default AITPRJ02;